module.exports = __webpack_public_path__ + "static/img/service (6).7cd59b64.jpg";